import { render, staticRenderFns } from "./enterpriseComissions.vue?vue&type=template&id=e4716426&"
import script from "./enterpriseComissions.vue?vue&type=script&lang=ts&"
export * from "./enterpriseComissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports